export const getIsInsideIframe = () => window.self !== window.top

export const getIsInsideWindow = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (window as any).isDetached || getIsInsideIframe()
}
